import React, { useCallback } from 'react';

// DEPENDENCIES
import { useParams } from 'react-router-dom';

// GLOBAL VARIABLES
import { ENDPOINTS } from 'endpoints.js';

// HELPERS/FUNCTIONS
import { apiFetch, modalFunctions } from 'functions.js';

// GLOBAL COMPONENTS
import Button from 'core/tools/Button';

// MAIN COMPONENT
const PushToTTMSButton = () => {
  const { recordID } = useParams();

  const handlePushToTTMS = useCallback(() => {
    apiFetch({
      method: 'PUT',
      endpoint: ENDPOINTS.sales.pushToTTMS(recordID),
      loadingMessage: 'Pushing order to TTMS',
      errorMessage: 'Unable to push order to TTMS.',
      successMessage: 'Order pushed to TTMS.'
    });
  }, [recordID]);

  return (
    <Button
      onClick={() =>
        modalFunctions.add({
          type: 'confirmation',
          title: 'Confirm Push Order to TTMS',
          body: 'Are you sure want to send this sale to TTMS?',
          spacing: 'sm',
          closeButton: false,
          continueButton: {
            label: 'Confirm',
            onClick: handlePushToTTMS
          }
        })
      }
      label="Push Order to TTMS"
      outline
      fullWidth={false}
      size="sm"
    />
  );
};

// EXPORT
export default PushToTTMSButton;
